export const MarketValueDownIcon = (props) => (
  <svg
    fill="currentColor"
    height="16px"
    viewBox="0 0 24 24"
    width="16px"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M6 9l6 6 6-6z" />
  </svg>
);
